const productCards = document.querySelectorAll(`product-card#product-card`);

productCards.forEach(productCard => {
  // Function to set the variant ID
  const setVariant = (inputElement) => {
    const variantId = inputElement.getAttribute('data-variant-id');

    if (variantId) {
      const hiddenInput = productCard.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = variantId;
      }
    } 
  };

  // Check for initially selected input with `data-selected` attribute
  const selectedInput = productCard.querySelector('input[data-selected]');
  if (selectedInput) {
    setVariant(selectedInput);
  } 

  // Add event listener to inputs with `custom-option-swatch` attribute
  const optionInputs = productCard.querySelectorAll('input[custom-option-swatch]');
  optionInputs.forEach(input => {
    input.addEventListener('change', (event) => {
      setVariant(event.target); // Run the variant-setting action for the selected input
    });
  });
});
